/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

"use strict";

import BackIcon from "./BackIcon";

export default BackIcon;
